import React from "react";
import { withLocalize } from "react-localize-redux";
import { Link } from "react-router-dom";
import { auth, global, guest } from "../../App/routes";

const Breadcrumbs = ({ data, translate }) => {
  const ROUTES = {
    auth: { ...auth },
    global: { ...global },
    guest: { ...guest },
  };

  return (
    <div className="Breadcrumbs d-flex justify-content-start align-items-center">
      {Boolean(data.length) &&
        data
          .map((item, index) =>
            item.route &&
            item.route.split(".").length &&
            ROUTES[item.route.split(".")[0]] &&
            ROUTES[item.route.split(".")[0]][item.route.split(".")[1]] ? (
              <Link
                key={index}
                to={
                  ROUTES[item.route.split(".")[0]][item.route.split(".")[1]]
                    .link
                }
                className="item link"
                state={item?.state}
              >
                <span>{item.customTitle || translate(item.title)}</span>
              </Link>
            ) : (
              <span key={index} className="item cursor--default">
                {`customTitle` in item
                  ? item.customTitle
                  : translate(item.title)}
              </span>
            )
          )
          .reduce((prev, curr, index) => [
            prev,
            <span key={`s-${index}`} className="seperator cursor--default">
              &gt;
            </span>,
            curr,
          ])}
    </div>
  );
};

export default withLocalize(Breadcrumbs);
